module.exports = __webpack_public_path__ + "static/media/down.c536db5a.svg";